import * as yup from 'yup';
import _ from 'lodash';

function isSameToAndFrom (this: any, value: any): boolean {
    return value?.countryCode && this.parent.from?.code !== this.parent.to?.code;
}

export const viewScheduleFormValidations = yup.object().shape({
    carrier: yup.string().notOneOf(['-Select-'], 'Carrier is required').required('Carrier is required'),
    flightDateTime: yup.string().required('Filght Date/Time is required'),
    from: yup.object().test('from', 'From field is not valid', isSameToAndFrom).required('From is required.'),
    to: yup.object().test('to', 'To field is not valid', isSameToAndFrom).required('To is required.')
});

const flightSort = (a, b) => a[0]?.flight.localeCompare(b[0]?.flight, undefined, {numeric: true})

const departSort = (a, b) => {
    const depart1 = Date.parse(`${a[0].departDate} ${a[0]?.departTime}`)
    const depart2 = Date.parse(`${b[0].departDate} ${b[0]?.departTime}`)
    if (depart1 > depart2) return 1;
    else if (depart1 < depart2) return -1;
    return 0;
}

const arrivalSort = (a, b) => {
    const arrival1 = Date.parse(`${a[a.length - 1].arrivalDate} ${a[a.length - 1]?.arrivalTime}`);
    const arrival2 = Date.parse(`${b[b.length - 1].arrivalDate} ${b[b.length - 1]?.arrivalTime}`);
    if (arrival1 > arrival2) return 1;
    if (arrival1 < arrival2) return -1;
    return 0;
}

const aircraftSort = (a, b) => a[0]?.aircraft.localeCompare(b[0]?.aircraft, undefined, {numeric: true});

const sortByDepartTime = (a, b) => {
    let value = departSort(a, b);
    if (value === 0) {
        value = arrivalSort(a, b);
    }
    if (value === 0) {
        value = flightSort(a, b);
    }
    if (value === 0) {
        value = aircraftSort(a, b);
    }
    return value;
};

const sortByArrivalTime = (a, b) => {
    let value = arrivalSort(a, b);
    if (value === 0) {
        value = departSort(a, b);
    }
    if (value === 0) {
        value = flightSort(a, b);
    }
    if (value === 0) {
        value = aircraftSort(a, b);
    }
    return value;
};

const sortByFlight = (a, b) => {
    let value = flightSort(a, b);
    if (value === 0) {
        value = departSort(a, b);
    }
    if (value === 0) {
        value = arrivalSort(a, b);
    }
    if (value === 0) {
        value = aircraftSort(a, b);
    }
    return value;
};

const sortByAircraft = (a, b) => {
    let value = aircraftSort(a, b);
    if (value === 0) {
        value = departSort(a, b);
    }
    if (value === 0) {
        value = arrivalSort(a, b);
    }
    if (value === 0) {
        value = flightSort(a, b);
    }
    return value;
};

const sortByOrder = (order: string, arr: any[]) => order === 'asc' ? arr : arr.reverse()

export const stableSort = (array: any[], order: string, orderBy: string) => {
    switch (orderBy) {
        case 'flight':
            return sortByOrder(order, array.sort(sortByFlight));
        case 'departTime':
            return sortByOrder(order, array.sort(sortByDepartTime));
        case 'arrivalTime':
            return sortByOrder(order, array.sort(sortByArrivalTime));
        case 'aircraft':
            return sortByOrder(order, array.sort(sortByAircraft));
    }
}

const formatTime = (time: string): string => {
    time = time.trim();
    if (time !== '-' && time.length >= 4) {
        if (time.includes(':')) {
            return time.slice(0, 5);
        }
        return time.slice(0, 2) + ':' + time.slice(2, 4);
    }
    return '-';
}

const formatDate = (date: string): string => {
    const d = new Date(date);
    const options: Intl.DateTimeFormatOptions = {
        month: 'short',
        day: '2-digit'
    };
    return d.toLocaleDateString('en-US', options)
};

const formatStatus = (status: string): string => {
    if (status === null || status?.toLowerCase() === 'null') {
        return 'Scheduled';
    }
    return status.toUpperCase().slice(0, 1) + status.toLowerCase().slice(1);
}

export const formatResponse = (response: any[]) => {
    // TODO: Need to map for Actual time => Discussions
    const data: object[] = [];
    response?.forEach(entry => {
        const arr: object[] = [];
        entry?.SEG?.forEach(segment => {
            const temp = {
                flight: '',
                departure: '',
                // departNewTime: '',
                departTime: '',
                departDate: '',
                departDisplayDate: '',
                arrival: '',
                // arrivalNewTime: '',
                arrivalTime: '',
                arrivalDisplayDate: '',
                arrivalDate: '',
                aircraft: '',
                status: ''
            };
            temp.flight = _.get(segment, 'FLTINFO.FLIGHT', '-');
            temp.departure = _.get(segment, 'ORIGIN.STATION', '-');
            temp.departTime = formatTime(_.get(segment, 'FLTINFO.DEP.TIME', '-'));
            temp.departDate = _.get(segment, 'FLTINFO.DEP.DATE', '-');
            temp.departDisplayDate = formatDate(_.get(segment, 'FLTINFO.DEP.DATE', '-'));
            // temp.departNewTime = formatTime(_.get(segment, 'FLTINFO.DEP.TIME', '-')); // TODO
            temp.arrival = _.get(segment, 'DEST.STATION', '-');
            temp.arrivalTime = formatTime(_.get(segment, 'FLTINFO.ARR.TIME', '-'));
            temp.arrivalDate = _.get(segment, 'FLTINFO.ARR.DATE', '-');
            temp.arrivalDisplayDate = formatDate(_.get(segment, 'FLTINFO.ARR.DATE', '-'));
            // temp.arrivalNewTime = formatTime(_.get(segment, 'FLTINFO.ARR.TIME', '-')); // TODO
            temp.aircraft = _.get(segment, 'FLTINFO.AIRCFT', '-');
            temp.status = formatStatus(_.get(segment, 'FLTINFO.ARR.STATUS', '-'));
            arr.push(temp);
        });
        data.push(arr);
    });
    return data;
}
